import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-form-buttons',
  standalone: true,
  imports: [RouterModule], 
  templateUrl: './form-buttons.component.html',
  styleUrl: './form-buttons.component.css',
})
export class FormButtonsComponent {}
